
    import "src/app/AppAdmin/D2R/ExternalRetailers/index.module.scss?farm_css_modules";
    
    export default {"page": `page-7aed49b7`}
    